import { render, staticRenderFns } from "./UsePassword.vue?vue&type=template&id=766bace9&scoped=true"
import script from "./UsePassword.vue?vue&type=script&lang=js"
export * from "./UsePassword.vue?vue&type=script&lang=js"
import style0 from "./UsePassword.vue?vue&type=style&index=0&id=766bace9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766bace9",
  null
  
)

export default component.exports